import { navigate, type Route } from '../router'

// Persistent left nav on desktop; a slide-over drawer on mobile.
const ITEMS: { label: string; to: string; match: Route['name'][] }[] = [
  { label: 'Dashboard', to: '#/', match: ['dashboard'] },
  { label: 'Today', to: '#/today', match: ['today'] },
  { label: 'To-Do', to: '#/todos', match: ['todos'] },
  { label: 'Notes', to: '#/notes', match: ['notes'] },
  { label: 'Chat', to: '#/chat', match: ['chat'] },
  { label: 'Clients', to: '#/clients', match: ['clients', 'client-new', 'tracker', 'client-settings', 'client-invoices', 'client-notes'] },
  { label: 'Settings', to: '#/settings', match: ['settings'] },
]

function NavList({ active, onNavigate }: { active: Route['name']; onNavigate?: () => void }) {
  return (
    <nav className="flex flex-col gap-1 px-3">
      {ITEMS.map((it) => {
        const on = it.match.includes(active)
        return (
          <button
            key={it.label}
            onClick={() => {
              navigate(it.to)
              onNavigate?.()
            }}
            className={
              'rounded-md px-3 py-2 text-left text-sm font-medium ' +
              (on ? 'bg-slate-900 text-white' : 'text-slate-600 hover:bg-slate-100')
            }
          >
            {it.label}
          </button>
        )
      })}
    </nav>
  )
}

function Brand() {
  return (
    <div className="flex items-center gap-2 px-5 py-5">
      <span className="flex h-7 w-7 items-center justify-center rounded-md bg-slate-900 text-sm font-bold text-white">⏱</span>
      <span className="font-semibold tracking-tight text-slate-900">Time Tracker</span>
    </div>
  )
}

export default function Sidebar({ active, open, onClose }: { active: Route['name']; open: boolean; onClose: () => void }) {
  return (
    <>
      {/* Desktop: static column */}
      <aside className="no-print hidden w-52 shrink-0 flex-col border-r border-slate-200 bg-white lg:flex">
        <Brand />
        <NavList active={active} />
      </aside>

      {/* Mobile: slide-over drawer */}
      <div className={'no-print fixed inset-0 z-50 lg:hidden ' + (open ? '' : 'pointer-events-none')}>
        <div className={'absolute inset-0 bg-black/30 transition-opacity ' + (open ? 'opacity-100' : 'opacity-0')} onClick={onClose} />
        <aside className={'absolute inset-y-0 left-0 flex w-60 flex-col bg-white shadow-xl transition-transform ' + (open ? 'translate-x-0' : '-translate-x-full')}>
          <div className="flex items-center justify-between pr-3">
            <Brand />
            <button className="rounded p-1 text-slate-400 hover:bg-slate-100" onClick={onClose} aria-label="Close menu">
              ✕
            </button>
          </div>
          <NavList active={active} onNavigate={onClose} />
        </aside>
      </div>
    </>
  )
}
